<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Entrada Folio:{{folio}}
            <div>
              <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
              </CButton>
              <router-link :to="{ name: 'Entrada', params: { config: config } }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </router-link>
            </div>
          </CCardHeader>

          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CCol sm="12" class="text-right">
              {{ this.item.author.correo }}
            </CCol>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  v-model="date"
                  disabled
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Almacén:</label>
                <CSelect
                  :value.sync="almacen"
                  disabled
                  :horizontal="{ input: 'col-sm-12' }"
                  :options="almacenes"
                  placeholder="Selecciona un almacén"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="folio_proveedor"
                  disabled
                  label="Folio proveedor"
                  placeholder="Folio proveedor..."
                  type="text"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Proveedor:</label>
                <CSelect
                  :value.sync="proveedor"
                  disabled
                  :horizontal="{ input: 'col-sm-12' }"
                  :options="proveedores"
                  placeholder="Selecciona un proveedor"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Comentarios:</label>
                <CTextarea v-model="comentarios" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="onFetch"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <CRow>
              <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                <i class="fa fa-spinner fa-pulse"></i>
              </CButton>
              <CButton v-else @click="()=>{fetching=true}" class="px-4 mx-3 btn-lg" color="success">
                <span>Actualizar</span>
              </CButton>
            </CRow>
            <CModal
              size="sm"
              title="Entrada"
              :centered="true"
              color="warning"
              :show.sync="warningModal"
            >{{ error }}</CModal>
            <CModal
              size="sm"
              title="Entrada"
              :centered="true"
              color="success"
              :show.sync="successModal"
              >Guardado con éxito.
              <template #footer>
                <CButton @click="successModal = false"  color="success">Aceptar</CButton>
              </template>
            </CModal>
            <hr class="my-4 line" />
            <CRow>
              <CCol sm="12">
                <CDataTable
                  hover
                  sorter
                  bordered
                  small
                  fixed
                  :items="detalles"
                  :fields="fieldsSecondModal"
                >
                  <template #producto_id="{item}">
                    <td class="py-2">{{ getProducto(item.producto_id) }}</td>
                  </template>
                  <template #unidad="{item}">
                    <td class="py-2">{{ getProdUnidad(item.producto_id) }}</td>
                  </template>
                  <template #importe="{item}">
                    <td class="py-2">
                      ${{ (item.cantidad * item.costo_unitario).toFixed(2) }}
                    </td>
                  </template>
                  <template #under-table>
                    <h5 class="text-right padding-left-custom">
                      Total:
                      <span class="ml-3">${{ totalDetails }}</span>
                    </h5>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const fieldsSecondModal = [
  { key: "producto_id", label: "Productos", _style: "width:20%" },
  { key: "unidad", label: "Unidad", _style: "width:20%" },
  { key: "cantidad", _style: "width:20%" },
  { key: "costo_unitario", _style: "width:20%" },
  { key: "importe", _style: "width:20%" }
];

export default {
  name: "VerEntrada",

  data() {
    return {
      folio: this.$route.params.id,
      config: this.$route.params.config,
      item: {},
      detalles: [],
      date: null,
      almacen: "",
      almacenes: [],
      folio_proveedor: "",
      proveedor: "",
      proveedores: [],
      unidad: "Unidad",
      fieldsSecondModal,
      isLoading: false,
      productos: [],
      producto: null,
      productosAll: [],
      cantidad: null,
      costo: null,
      comentarios: '',
      successModal: false,
      warningModal: false,
      error: "",
      isLoadingPage: false,
      currentAlertCounter: 0,
      fetching: false,
      medias:[],
      loader: false,
    };
  },

  created() {
    this.isLoading = true;
    this.$store;

    const serv = [
      this.$store.dispatch("customDocumentoHTTP", {
        schema: "entradas",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"]: ["*"]
      }),
      this.$store.dispatch("customHTTP", {
        schema: "almacenes",
        filter: {
          wherein: [
            {
              field: "payload->ubicacion_id",
              value: [this.ubicacionRaiz]
            }
          ]
        }
      }),
      this.$store.dispatch("customHTTP", {
        schema: "proveedores",
      })
    ];

    Promise.all(serv)
      .then(([item, almacenes, proveedores]) => {
        
        this.item = item.data[0];
        this.proveedores = proveedores.data.map(cultivo => {
          return { value: cultivo.id, label: cultivo.payload.nombre };
        });
        this.almacenes = almacenes.data.map(cultivo => {
          return { value: cultivo.id, label: cultivo.payload.nombre };
        });
        this.almacen = this.item.payload.encabezado.almacen_id;
        this.folio_proveedor = this.item.payload.encabezado.folio_proveedor;
        this.proveedor = this.item.payload.encabezado.proveedor_id;
        
        this.productosAll = this.item.payload.detalles.map(m=>m._relaciones?.producto||{})
        this.detalles = this.item.payload.detalles;
        this.comentarios = this.item.payload.encabezado.comentarios;
        this.medias = this.item.payload.anexos;

        let dateDocto = new Date(this.item.payload.encabezado.fechahora);

        let year = dateDocto.getFullYear();
        let month = ("0" + (dateDocto.getMonth() + 1)).slice(-2);
        let day = ("0" + dateDocto.getDate()).slice(-2);

        this.date = `${year}-${month}-${day}`;
      })
      .finally(() => (this.isLoading = false));
  },

  computed: {
    totalDetails() {
      if (this.detalles.length) {
        return this.detalles
          .reduce(
            (acount, detail) =>
              Number(acount) +
              Number(detail.cantidad) * Number(detail.costo_unitario),
            0
          )
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "0.00";
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  methods: {
    getReporte(){
      if(this.loader){
        return
      }
      this.loader = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_entradas",
        params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);

      
        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de entradas.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader = false
          this.$forceUpdate();
        });
    },
    async onFetch(medias){
      this.fetching=false
      const {folio,serie,schema,payload} = this.item
      const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
      body.payload.anexos = medias
      delete body.payload.encabezado._relaciones
      this.$store.dispatch("customDocumentoRemplazarHTTP",body)
        .then(()=>{
          this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Produccion" });
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.fetching=false
          return;
        })

        .finally(() => {
          this.fetching=false
          if (!this.warningModal) {
            this.successModal = true;
          }
        });
      
    },
    async pushMedia(files) {
      const arr = [];
      
      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;
        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    getProducto(producto_id) {
      const productoActual = this.productosAll.filter(
        producto => producto.id == producto_id
      );

      return productoActual[0].payload.nombre;
    },
    getProdUnidad(producto_id) {
      const productoActual = this.productosAll.filter(
        producto => producto.id == producto_id
      );

      return productoActual[0].payload.unidad;
    }
  }
};
</script>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
